<desy-dropdown
  [ngClass]="{ 'arrow-hidden': hiddenArrow, 'bg-selected': selected }"
  [classes]="classes"
  [value]="selected"
  (valueChange)="onSelectValue($event)">
  <div class="flex gap-2 justify-center items-center">
    <span [class]="icon"></span>
    {{ selected ? getSelectedLabel() : label }}
  </div>
  <desy-content>
    <div class="p-2">
      <div class="max-h-64 min-w-full max-w-full overflow-y-auto">
        <ul>
          @for (option of options; track option.value) {
            <li
              class="min-w-full py-2 px-4 hover:bg-primary-light hover:text-black cursor-pointer"
              [class.bg-warning-base]="selected === option.value"
              [class.text-black]="selected === option.value"
              (click)="onSelectValue(option.value)">
              {{ option.label }}
            </li>
          }
        </ul>
      </div>
    </div>
  </desy-content>
</desy-dropdown>
